import React from 'react';
import { useQuery } from '@tanstack/react-query';
import ReferralChannelSelect, {
  ReferralChannelSelectProps,
} from './ReferralChannelSelect';
import { ReferralChannel } from 'api/mylers/types';
import { getReferralChannels } from 'api/mylers';

const ReferralChannelsSelectContainer: React.FC<
  Omit<ReferralChannelSelectProps, 'channels'>
> = props => {
  const { data: referralChannels, isLoading } = useQuery<ReferralChannel[]>(
    ['referralChannels'],
    () => getReferralChannels()
  );

  if (isLoading || !referralChannels) {
    return null;
  }

  const initialOptions = {
    value: '',
    name: 'Select channel',
  };

  const transformedOptions = referralChannels.map(channel => ({
    value: `${channel.id.toString()}-${channel.name}`,
    name: channel.name,
  }));

  const channelOptions = [initialOptions, ...transformedOptions];
  return <ReferralChannelSelect channels={channelOptions} {...props} />;
};

export default ReferralChannelsSelectContainer;
